import { isAndroid } from "shared/utils/userAgent.utils";

export function openUrlInNewTab(url: string): Window | null {
    return window.open(url, "");
}

export async function openPdfInNewTab(url: string, downloadPdf: () => Promise<Blob>): Promise<void> {
    // It seems all android browsers do not support previewing a PDF in a new tab
    if (isAndroid()) {
        const response = await downloadPdf();
        window.location.assign(window.URL.createObjectURL(response));
        return;
    }

    const newTab = openUrlInNewTab(url);
    if (!newTab) {
        return;
    }

    try {
        const response = await downloadPdf();
        newTab.location.replace(window.URL.createObjectURL(response));
    } catch {
        newTab.close();
    }
}
